/**
 * Coze Chat v3 (streaming): POST /v3/chat with stream:true, SSE lines event:/data:
 * Docs: https://docs.coze.cn/developer_guides/chat_v3
 *
 * Browser CORS may block direct calls; use App Proxy in production. Do not expose PAT in public themes.
 */
(function () {
  'use strict';

  var CONFIG_EL_ID = 'jewelry-coze-config';

  /** Match freyajewelry.shop URLs in plain text or after https?:// */
  var RE_FREYA_URL =
    /https?:\/\/(?:www\.)?freyajewelry\.shop[^\s\)\]"'<>]*/gi;
  var RE_FREYA_WWW = /www\.freyajewelry\.shop[^\s\)\]"'<>]*/gi;
  /** Markdown link pointing at freyajewelry.shop — remove entire bracket, keep optional label cleanup */
  var RE_FREYA_MD =
    /\[[^\]]*\]\(\s*(?:https?:\/\/)?(?:www\.)?freyajewelry\.shop[^)]*\)/gi;

  function readConfig() {
    var el = document.getElementById(CONFIG_EL_ID);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getCozeUserId(cfg) {
    if (cfg.shopifyCustomerId) {
      return 'shopify_customer_' + String(cfg.shopifyCustomerId);
    }
    try {
      var k = 'jewelry_coze_uid';
      var id = sessionStorage.getItem(k);
      if (!id) {
        id = 'guest_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem(k, id);
      }
      return id;
    } catch (e) {
      return 'guest_' + Date.now();
    }
  }

  function cozeHeaders(token) {
    return {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    };
  }

  function extractFirstFreyaLink(raw) {
    if (!raw) return null;
    var m = raw.match(RE_FREYA_URL);
    if (m && m[0]) return trimTrailingJunk(m[0]);
    m = raw.match(RE_FREYA_WWW);
    if (m && m[0]) return trimTrailingJunk('https://' + m[0]);
    return null;
  }

  function trimTrailingJunk(url) {
    return url.replace(/[,;.:]+$/, '');
  }

  function stripFreyaLinksFromCopy(raw) {
    if (!raw) return '';
    var t = String(raw);
    t = t.replace(RE_FREYA_MD, '');
    t = t.replace(RE_FREYA_URL, '');
    t = t.replace(RE_FREYA_WWW, '');
    t = t.replace(/\n{3,}/g, '\n\n').replace(/[ \t]{2,}/g, ' ');
    return t.trim();
  }

  function formatBirthdayEn(isoDate) {
    if (!isoDate) return '';
    var d = new Date(isoDate + 'T12:00:00');
    if (isNaN(d.getTime())) return isoDate;
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  function parseSseBlock(block) {
    var eventName = '';
    var dataLines = [];
    var lines = block.split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (line.indexOf('event:') === 0) {
        eventName = line.slice(6).trim();
      } else if (line.indexOf('data:') === 0) {
        dataLines.push(line.slice(5).replace(/^\s/, ''));
      }
    }
    return { event: eventName, data: dataLines.join('\n') };
  }

  function createChatStream(apiBase, token, botId, userId, userText, handlers, signal) {
    var url = apiBase + '/v3/chat';
    var payload = {
      bot_id: botId,
      user_id: userId,
      stream: true,
      auto_save_history: true,
      additional_messages: [
        {
          role: 'user',
          content: userText,
          content_type: 'text',
        },
      ],
    };
    return fetch(url, {
      method: 'POST',
      headers: cozeHeaders(token),
      body: JSON.stringify(payload),
      signal: signal,
    }).then(function (res) {
      var ct = (res.headers.get('content-type') || '').toLowerCase();
      if (ct.indexOf('application/json') !== -1) {
        return res.json().then(function (json) {
          if (!res.ok) {
            throw new Error((json && json.msg) || 'Request failed HTTP ' + res.status);
          }
          if (typeof json.code !== 'undefined' && json.code !== 0) {
            throw new Error(json.msg || 'API code ' + json.code);
          }
          throw new Error('Expected event stream but received JSON.');
        });
      }
      if (!res.ok) {
        return res.text().then(function (t) {
          throw new Error('HTTP ' + res.status + ': ' + (t || res.statusText));
        });
      }
      if (!res.body || !res.body.getReader) {
        throw new Error('ReadableStream not available in this browser.');
      }
      return pumpSse(res.body, handlers, signal);
    });
  }

  function pumpSse(body, handlers, signal) {
    var reader = body.getReader();
    var decoder = new TextDecoder();
    var carry = '';
    var answerRaw = '';
    var streamEnded = false;

    function finishOnce() {
      if (streamEnded) return;
      streamEnded = true;
      handlers.onStreamDone();
    }

    function applyAnswerUpdate(partialOrFull, isFullReplace) {
      if (isFullReplace) {
        answerRaw = partialOrFull || '';
      } else if (partialOrFull) {
        answerRaw += partialOrFull;
      }
      var link = extractFirstFreyaLink(answerRaw);
      var visible = stripFreyaLinksFromCopy(answerRaw);
      handlers.onTick(visible, link);
    }

    function processBlock(block) {
      var p = parseSseBlock(block);
      var ev = p.event;
      var dataStr = p.data;
      if (!ev && !dataStr) return;

      if (ev === 'done' || dataStr === '[DONE]') {
        finishOnce();
        return;
      }

      if (ev === 'error') {
        throw new Error(dataStr || 'Stream error event');
      }

      var obj = null;
      if (dataStr) {
        try {
          obj = JSON.parse(dataStr);
        } catch (e) {
          return;
        }
      }

      // Stream `data` is usually a Message object; some proxies may nest under `message`.
      if (ev === 'conversation.message.delta' && obj) {
        var dc = answerContentFromPayload(obj);
        if (dc) applyAnswerUpdate(dc, false);
      }

      if (ev === 'conversation.message.completed' && obj) {
        var fc = answerContentFromPayload(obj);
        if (fc) applyAnswerUpdate(fc, true);
      }

      if (ev === 'conversation.chat.failed' && obj) {
        var err = (obj.last_error && obj.last_error.msg) || 'Chat failed';
        throw new Error(err);
      }
    }

    function answerContentFromPayload(o) {
      if (!o) return null;
      if (o.type === 'answer' && o.content) return String(o.content);
      if (o.message && o.message.type === 'answer' && o.message.content) {
        return String(o.message.content);
      }
      if (o.role === 'assistant' && o.content && (!o.type || o.type === 'answer')) {
        return String(o.content);
      }
      return null;
    }

    function flushBuffer() {
      var re = /\r\n\r\n|\n\n/;
      var m;
      while ((m = carry.match(re))) {
        var idx = m.index;
        var block = carry.slice(0, idx);
        carry = carry.slice(idx + m[0].length);
        if (block.trim()) {
          processBlock(block);
        }
      }
    }

    function read() {
      return reader.read().then(function (result) {
        if (signal && signal.aborted) {
          reader.cancel().catch(function () {});
          return;
        }
        if (result.value) {
          carry += decoder.decode(result.value, { stream: !result.done });
          flushBuffer();
        }
        if (result.done) {
          if (carry.trim()) {
            processBlock(carry);
            carry = '';
          }
          finishOnce();
          return;
        }
        return read();
      });
    }

    return read().catch(function (err) {
      if (signal && signal.aborted) return;
      throw err;
    });
  }

  function bindForm() {
    var cfg = readConfig();
    var form = document.getElementById('jewelry-coze-form');
    var statusEl = document.getElementById('jewelry-coze-status');
    var resultEl = document.getElementById('jewelry-coze-result');
    var submitBtn = document.getElementById('jewelry-coze-submit');
    var orderBtn = document.getElementById('jewelry-coze-order-btn');
    var ctaWrap = document.getElementById('jewelry-coze-cta');

    if (!form || !cfg) return;

    var token = cfg.token;
    var botId = cfg.botId;
    var apiBase = cfg.apiBase || 'https://api.coze.cn';
    var streamAbort = null;

    if (!token || token.indexOf('TODO_COZE') === 0) {
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.classList.add('is-error');
        statusEl.textContent =
          'Replace TODO_COZE_PERSONAL_ACCESS_TOKEN in the section Liquid with your Coze PAT.';
      }
      return;
    }
    if (!botId || botId.indexOf('TODO_COZE') === 0) {
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.classList.add('is-error');
        statusEl.textContent = 'Replace TODO_COZE_BOT_ID with your published Bot ID.';
      }
      return;
    }

    var lastOrderUrl = null;

    function setOrderUi(url) {
      lastOrderUrl = url;
      if (!orderBtn || !ctaWrap) return;
      if (url) {
        ctaWrap.hidden = false;
        orderBtn.hidden = false;
        orderBtn.disabled = false;
      } else {
        ctaWrap.hidden = true;
        orderBtn.hidden = true;
        orderBtn.disabled = true;
      }
    }

    if (orderBtn) {
      orderBtn.addEventListener('click', function () {
        if (!lastOrderUrl) return;
        window.open(lastOrderUrl, '_blank', 'noopener,noreferrer');
      });
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var birthday = document.getElementById('jewelry-coze-birthday');
      var wish = document.getElementById('jewelry-coze-wish');
      if (!birthday || !wish) return;

      if (streamAbort) {
        streamAbort.abort();
      }
      streamAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var signal = streamAbort ? streamAbort.signal : undefined;

      if (!birthday.value) {
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.classList.add('is-error');
          statusEl.textContent = 'Please select your birthday.';
        }
        birthday.focus();
        return;
      }
      if (!wish.value) {
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.classList.add('is-error');
          statusEl.textContent = 'Please choose a wish.';
        }
        wish.focus();
        return;
      }

      var birthStr = formatBirthdayEn(birthday.value);
      var userText =
        'My birthday is ' +
        birthStr +
        '. My wish is about ' +
        wish.value +
        '. Please recommend jewelry for me.';

      if (statusEl) {
        statusEl.hidden = false;
        statusEl.classList.remove('is-error');
        statusEl.textContent = 'Streaming response…';
      }
      if (resultEl) resultEl.textContent = '';
      setOrderUi(null);
      if (submitBtn) submitBtn.disabled = true;

      var userId = getCozeUserId(cfg);

      createChatStream(
        apiBase,
        token,
        botId,
        userId,
        userText,
        {
          onTick: function (visibleText, link) {
            if (resultEl) resultEl.textContent = visibleText;
            setOrderUi(link);
          },
          onStreamDone: function () {
            if (statusEl) {
              statusEl.classList.remove('is-error');
              statusEl.textContent = 'Done.';
            }
            if (submitBtn) submitBtn.disabled = false;
          },
        },
        signal
      ).catch(function (err) {
        if (signal && signal.aborted) return;
        var msg = err && err.message ? err.message : String(err);
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.classList.add('is-error');
          statusEl.textContent = msg;
        }
        if (
          msg.indexOf('Failed to fetch') !== -1 ||
          msg.indexOf('NetworkError') !== -1 ||
          msg.indexOf('aborted') !== -1
        ) {
          if (statusEl && msg.indexOf('aborted') === -1) {
            statusEl.textContent +=
              ' If this is a CORS issue, proxy Coze through your backend or Shopify App Proxy.';
          }
        }
        if (submitBtn) submitBtn.disabled = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindForm);
  } else {
    bindForm();
  }
})();
